import { useState } from "react";
import { Tabs } from "antd";
import { FileSearchOutlined, AuditOutlined, ProfileOutlined } from "@ant-design/icons";
import SideBar from "../../components/SideBar";
import NavBar from "../../components/NavBar";
import Footer from "../../components/Footer";
import ListSinistres from "./ListSinistres";
import ValidationEvaluations from "./ValidationEvaluations";

/**
 * Écran fusionné « Dossiers sinistres » (menu v2) regroupant en onglets :
 *  - Sinistres            → ListSinistres (listing des sinistres)
 *  - Instruire un dossier → ValidationEvaluations (file d'instruction, actions)
 *  - Listing des évaluations → ValidationEvaluations en lecture seule (consultation)
 *
 * Les écrans sont réutilisés en mode `embedded` (contenu seul, pas de chrome dupliqué).
 * destroyInactiveTabPane → un seul onglet charge ses données à la fois.
 */
const DossiersSinistres = () => {
    const [tab, setTab] = useState("sinistres");

    const items = [
        {
            key: "sinistres",
            label: <span><FileSearchOutlined /> Sinistres</span>,
            children: <ListSinistres embedded />,
        },
        {
            key: "instruction",
            label: <span><AuditOutlined /> Instruire un dossier</span>,
            children: <ValidationEvaluations embedded />,
        },
        {
            key: "evaluations",
            label: <span><ProfileOutlined /> Listing des évaluations</span>,
            children: <ValidationEvaluations embedded readOnly />,
        },
    ];

    return (
        <div className="layout-wrapper layout-content-navbar">
            <div className="layout-container">
                <SideBar currentMenu={"SINISTRES"} />
                <div className="layout-page">
                    <NavBar />
                    <div className="content-wrapper">
                        <div className="container-xxl flex-grow-1 container-p-y">
                            <Tabs
                                activeKey={tab}
                                onChange={setTab}
                                type="card"
                                items={items}
                                destroyInactiveTabPane
                            />
                        </div>
                        <Footer />
                        <div className="content-backdrop fade"></div>
                    </div>
                </div>
            </div>
            <div className="layout-overlay layout-menu-toggle"></div>
            <div className="drag-target"></div>
        </div>
    );
};

export default DossiersSinistres;
